import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ChatProvider } from './stores/ChatContext';
import { PreferencesProvider } from './stores/PreferencesContext';
import { RequireAuth } from './auth/RequireAuth';
import { RequireAdmin } from './auth/RequireAdmin';
import { AppShell } from './components/layout/AppShell';
import { Spinner } from './components/common/Spinner';
import { LoginPage } from './pages/LoginPage';
import { ChatPage } from './pages/ChatPage';
import { NotFoundPage } from './pages/NotFoundPage';

// Lazy-loaded pages (not on critical path)
const HistoryPage = lazy(() => import('./pages/HistoryPage').then(m => ({ default: m.HistoryPage })));
const SettingsPage = lazy(() => import('./pages/SettingsPage').then(m => ({ default: m.SettingsPage })));
const AdminPage = lazy(() => import('./pages/AdminPage').then(m => ({ default: m.AdminPage })));
const UsagePage = lazy(() => import('./pages/UsagePage').then(m => ({ default: m.UsagePage })));
const ModerationPage = lazy(() => import('./pages/ModerationPage').then(m => ({ default: m.ModerationPage })));
const WhatsNewPage = lazy(() => import('./pages/WhatsNewPage').then(m => ({ default: m.WhatsNewPage })));

export function App() {
  return (
    <BrowserRouter>
      <PreferencesProvider>
        <ChatProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route element={<RequireAuth />}>
              <Route element={<AppShell />}>
                <Route index element={<ChatPage />} />
                <Route path="chat/:sessionId" element={<ChatPage />} />
                <Route path="history" element={<Suspense fallback={<div className="flex h-full items-center justify-center"><Spinner size="lg" /></div>}><HistoryPage /></Suspense>} />
                <Route path="settings" element={<Suspense fallback={<div className="flex h-full items-center justify-center"><Spinner size="lg" /></div>}><SettingsPage /></Suspense>} />
                <Route path="whats-new" element={<Suspense fallback={<div className="flex h-full items-center justify-center"><Spinner size="lg" /></div>}><WhatsNewPage /></Suspense>} />
                <Route element={<RequireAdmin />}>
                  <Route path="admin" element={<Suspense fallback={<div className="flex h-full items-center justify-center"><Spinner size="lg" /></div>}><AdminPage /></Suspense>} />
                  <Route path="admin/usage" element={<Suspense fallback={<div className="flex h-full items-center justify-center"><Spinner size="lg" /></div>}><UsagePage /></Suspense>} />
                  <Route path="admin/moderation" element={<Suspense fallback={<div className="flex h-full items-center justify-center"><Spinner size="lg" /></div>}><ModerationPage /></Suspense>} />
                </Route>
              </Route>
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </ChatProvider>
      </PreferencesProvider>
    </BrowserRouter>
  );
}
